import React, { memo, forwardRef } from "react";
const SvgDivision = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M18 9a2 2 0 11-4 0 2 2 0 014 0zM5 16c0-.552.413-1 .923-1h20.154c.51 0 .923.448.923 1s-.413 1-.923 1H5.923C5.413 17 5 16.552 5 16zm11 9a2 2 0 100-4 2 2 0 000 4z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgDivision.displayName = "SvgDivision";
const MemoForwardRef = memo(SvgDivision);
export default MemoForwardRef;
